import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { Hero } from '../components/sections/Hero';
import { TheProblem } from '../components/sections/TheProblem';
import { TheSolution } from '../components/sections/TheSolution';
import { Audience } from '../components/sections/Audience';
import { FAQAndPricing } from '../components/sections/FAQAndPricing';
import { Footer } from '../components/sections/Footer';
export function SalesPage() {
  useMetaPixel();
  return <main className="min-h-screen bg-cream-100 selection:bg-sage-300 selection:text-forest overflow-x-hidden" data-id="element-170">
      <Hero data-id="element-171" />
      <TheProblem data-id="element-172" />
      <TheSolution data-id="element-173" />
      <Audience data-id="element-174" />
      <FAQAndPricing data-id="element-175" />

      <Footer data-id="element-176" />
    </main>;
}